<template>
  <v-flex shrink>
    <v-tooltip top>
      <template #activator="{ on }">
        <v-checkbox v-on="on" v-model="showAll" class="mt-0" hide-details />
      </template>
      <span>{{showAll ? 'Esconder' : 'Mostrar'}} items que ya tienen "{{feature.name}}"</span>
    </v-tooltip>
  </v-flex>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    /**
     * The feature object with the onlyMissing property.
     */
    feature: {
      type: Object,
      required: true
    }
  },
  computed: {
    showAll: {
      get() {
        return !this.feature.onlyMissing;
      },
      set(value) {
        this.setOnlyMissing({ id: this.feature.id, value: !value });
      }
    }
  },
  methods: {
    ...mapActions("ner", ["setOnlyMissing"])
  }
};
</script>